import { authenticatedInstance } from '../index/index.service';
import type { PrinterAgentView } from 'shared-models/browser';
import { extractServiceErrorMessage } from '../shared/service-error.util';

// Summary: Web-side client for the printer-agents endpoints.
// Details: docs/function-library/web/services.md#printer-agents-service

export type { PrinterAgentView } from 'shared-models/browser';

export type CreatedPrinterAgent = PrinterAgentView & {
  token: string;
};

class PrinterAgentsService {
  async listAgents(tenantId: string, employeeSession: string): Promise<PrinterAgentView[]> {
    try {
      const response = await authenticatedInstance.get<PrinterAgentView[]>(
        `/tenants/${tenantId}/printer-agents`,
        { headers: { 'x-employee-session': employeeSession } },
      );
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, ''));
    }
  }

  async createAgent(
    tenantId: string,
    employeeSession: string,
    name: string,
  ): Promise<CreatedPrinterAgent> {
    try {
      const response = await authenticatedInstance.post<CreatedPrinterAgent>(
        `/tenants/${tenantId}/printer-agents`,
        { name },
        { headers: { 'x-employee-session': employeeSession } },
      );
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, ''));
    }
  }

  async revokeAgent(
    tenantId: string,
    employeeSession: string,
    agentId: number,
  ): Promise<PrinterAgentView> {
    try {
      const response = await authenticatedInstance.delete<PrinterAgentView>(
        `/tenants/${tenantId}/printer-agents/${agentId}`,
        { headers: { 'x-employee-session': employeeSession } },
      );
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, ''));
    }
  }
}

export const printerAgentsService = new PrinterAgentsService();





